<div class="px-4">
    <div class="text-lg mb-5"> Case Details <span class="text-sm">{{data.caseNumber}}</span></div>
</div>